<template>
  <div id="manage-intent" v-if="intent">
    <div>
      <v-layout wrap style="border-bottom: 1px solid #eee" class="mb-3" v-if="!isWelcome">
        <v-flex
          xs12
          sm5
          md6
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="px-2 pt-2"
        >
          <template v-if="readonlyName || isDefault">
            <p>{{ intentLabel(intent.intentname) }}</p>
          </template>
          <div v-else>
            <input
              type="text"
              :readonly="isReadonly"
              class="form-control"
              :placeholder="$t('Conversation')"
              v-model="intent.intentname"
              name="intentName"
              :data-vv-as="$t('Conversation')"
              aria-describedby="Intent Name"
              v-validate="
                'required|excludednew:{default},{welcome}' +
                (excludedName ? ',' + excludedName : '')
              "
            />
          </div>
          <span class="text-error" v-show="errors.has('intentName')">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex v-if="!livechat" xs12 sm7 md6 class="px-2 pt-2">
          <slot name="action"></slot>
          <div v-if="showReplyCommentSelectPost" class="text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn color="primary" small outline @click="showSelectPost = true">
                <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
                <v-icon small>edit</v-icon>
              </v-btn>
              <intent-select-post
                :includePost="intent.postidlist"
                :excludePost="intent.exceptpostidlist"
                :post_keywords="intent.post_keywords"
                :show="showSelectPost"
                :useexclude="true"
                @save="saveFilterPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>

            <v-btn color="grey" disabled v-else outline>
              <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn>
          </div>
        </v-flex>
        <v-flex v-if="!livechat" xs12 class="px-2 pt-1 pb-2" align-end>
          <v-layout row wrap>
            <v-flex xs6 class="text-xs-left">
              <template v-if="!hideStatus">
                <toggle-button
                  :value="intent.intentstatus"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="onChangeIntentStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                />
                <span class="mr-2">{{ $t('Turn On/Off Conversation') }}</span>
              </template>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap justify-end class="py-0 my-0">
                <div v-if="!hidePriority">
                  <v-checkbox
                    class="my-0 py-0"
                    hide-details
                    v-model="intent.ispriority"
                    color="success"
                    :label="$t('First Priority')"
                  ></v-checkbox>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex v-if="!livechat" xs12 sm6 class="pa-1 pl-2 pr-2">
          <template v-if="!isDefault && !hideQuestion">
            <intent-question v-model="intent.q_val"></intent-question>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px"></p>
          </template>
        </v-flex>
        <v-flex xs12 :sm6="!livechat" :sm12="livechat" class="pa-1">
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-comment
              :isLiveStream="isLiveStream"
              v-model="messages"
              :intentname="intent.intentname"
            ></intent-comment>
          </template>
          <template v-else-if="isWelcome && !showMultipleChannel">
            <slot name="welcome" v-bind="{ showMultipleChannel, changeSetting }"></slot>
          </template>
          <template v-else>
            <v-layout>
              <v-flex
                v-if="showMultipleChannel"
                class="channel"
                shrink
                style="border-right: 1px solid #eee"
              >
                <div
                  :class="{ 'primary white--text': tab == 'facebook' }"
                  @click="tab = 'facebook'"
                  class="py-1 pl-2 pr-2"
                  style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                >
                  <span class="fab fa-facebook"></span>
                </div>
                <div
                  :class="{ 'primary white--text': tab == 'line' }"
                  @click="tab = 'line'"
                  class="py-1 pl-2 pr-2"
                  style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                >
                  <span class="fab fa-line"></span>
                </div>
                <div
                  :class="{ 'primary white--text': tab == 'ig' }"
                  @click="tab = 'ig'"
                  class="py-1 pl-2 pr-2"
                  style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                >
                  <span class="fab fa-instagram"></span>
                </div>
              </v-flex>
              <v-flex style="overflow: auto" :key="timestamp">
                <template v-if="!showMultipleChannel">
                  <intent-group
                    v-model="messages"
                    :intentname="intent.intentname"
                    :showMultipleChannel="showMultipleChannel"
                    :channel="tab"
                    @changeSetting="changeSetting"
                    :hideSetting="hideSetting"
                    :availableBubbles="availableBubbles"
                  ></intent-group>
                </template>
                <template v-else>
                  <template v-if="tab == 'facebook'">
                    <intent-group
                      key="fb_message"
                      v-model="fb_messages"
                      :intentname="intent.intentname"
                      :showMultipleChannel="showMultipleChannel"
                      :channel="tab"
                      @changeSetting="changeSetting"
                      :hideSetting="hideSetting"
                      :availableBubbles="availableBubbles"
                    ></intent-group>
                  </template>
                  <template v-else-if="tab == 'line'">
                    <intent-group
                      key="line_message"
                      v-model="line_messages"
                      :intentname="intent.intentname"
                      :showMultipleChannel="showMultipleChannel"
                      @changeSetting="changeSetting"
                      :hideSetting="hideSetting"
                      :availableBubbles="availableBubbles"
                      :channel="tab"
                    ></intent-group>
                  </template>
                  <template v-else-if="tab == 'ig'">
                    <intent-group
                      key="ig_message"
                      v-model="ig_messages"
                      :intentname="intent.intentname"
                      :showMultipleChannel="showMultipleChannel"
                      @changeSetting="changeSetting"
                      :hideSetting="hideSetting"
                      :availableBubbles="availableBubbles"
                      :channel="tab"
                    ></intent-group>
                  </template>
                </template>
              </v-flex>
            </v-layout>
            <template v-if="!isWelcome && !isCommentToInbox && !livechat && !hideChoice">
              <div class="hr"></div>
              <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>

              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </template>
            <template v-else></template>
          </template>
        </v-flex>
      </v-layout>

      <div v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)" class="my-3">
        <div class="mt-4">
          <div class="pa-3">
            <div class="caption pb-2">Conversation Grouping</div>
            <div class="form-control" :class="{ 'has-error': errors.has('uuAreaName') }">
              <multiselect
                v-model="intent.group_conversation_id"
                :options="groupConversation"
                selectLabel
                selectedLabel
                :searchable="true"
                deselect-label
                label="name"
                track-by="id"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <template v-if="selectedBot.theme == 'universalutilities'">
        <template v-if="selectedBot.uu_areaname != '' && selectedBot.uu_areaname != null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control">
                <span class="primary--text">{{ selectedBot.uu_areaname }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="selectedBot.uu_areaname == '' || selectedBot.uu_areaname == null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control" :class="{ 'has-error': errors.has('uuAreaName') }">
                <multiselect
                  v-model="intent.intentgroup"
                  :options="areaName"
                  selectLabel
                  selectedLabel
                  :searchable="false"
                  deselect-label
                  data-vv-as="ประปา"
                  data-vv-name="uuAreaName"
                ></multiselect>
                <span class="text-error" v-show="errors.has('uuAreaName')">{{
                  errors.first('uuAreaName')
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-if="selectedBot.theme == 'mitsuwebchat'">
        <div class="mt-4">
          <div class="hr"></div>
          <div class="pa-3">
            <div class="caption">{{ $t('Department') }}</div>
            <div
              class="form-control"
              :class="{ 'has-error': errors.has('mitsuDepartment') }"
              v-if="$store.state.privilege.role == 'superadmin'"
            >
              <multiselect
                v-model="intent.intentgroup"
                :options="agentGroup"
                track-by="groupname"
                label="groupname"
                name="mitsuDepartment"
                :searchable="true"
                selectLabel
                selectedLabel
                deselect-label
                :data-vv-as="$t('Department')"
                data-vv-name="mitsuDepartment"
              ></multiselect>
              <span class="text-error" v-show="errors.has('mitsuDepartment')">{{
                errors.first('mitsuDepartment')
              }}</span>
            </div>
            <div v-else>
              <span>{{ intent.intentgroup.groupname }}</span>
            </div>
          </div>
        </div>
      </template>
      <template class="form-control" v-if="selectedBot && selectedBot.type === 'hopinnhr'">
        <div class="mt-4">
          <div class="hr"></div>
          <div class="pa-3">
            <v-layout wrap>
              <v-flex xs6 class="pr-2">
                <div class="caption">ตำแหน่ง</div>
                <div>
                  <multiselect
                    v-model="intent.custom_filter_2"
                    track-by="engname"
                    label="engname"
                    :options="positionOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                  ></multiselect>
                </div>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <div class="caption">สังกัด</div>
                <div>
                  <multiselect
                    v-model="intent.custom_filter_1"
                    track-by="engname"
                    label="engname"
                    :options="affiliationOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                  ></multiselect>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </template>
      <template v-if="isGpfBuddy">
        <div class="py-4 px-2">
          <v-layout row wrap>
            <v-flex xs3 class="px-1">
              <div class="form-control">
                <div class="primary--text caption">{{ $t('company') }}</div>
                <div>
                  <multiselect
                    v-model="intent.gpf_company_code"
                    :options="gpfCompanyOptions"
                    :allow-empty="false"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                    track-by="company_code"
                    label="company_name"
                    @input="onChangeGpfBuddyOptions('company')"
                  ></multiselect>
                </div>
              </div>
            </v-flex>
            <v-flex xs3 class="px-1">
              <div class="form-control">
                <div class="primary--text caption">{{ $t('work_group') }}</div>
                <div>
                  <multiselect
                    :disabled="
                      intent.gpf_company_code && intent.gpf_company_code.company_code === 'All'
                    "
                    v-model="intent.gpf_group_code"
                    :options="gpfGroupOptions"
                    :allow-empty="false"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                    track-by="group_code"
                    label="group_name"
                    @input="onChangeGpfBuddyOptions('group')"
                  ></multiselect>
                </div>
              </div>
            </v-flex>
            <v-flex xs3 class="px-1">
              <div class="form-control">
                <div class="primary--text caption">{{ $t('department') }}</div>
                <div>
                  <multiselect
                    :disabled="
                      intent.gpf_company_code && intent.gpf_company_code.company_code === 'All'
                    "
                    v-model="intent.gpf_department_code"
                    :options="gpfDepartmentOptions"
                    :allow-empty="false"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                    track-by="department_code"
                    label="department_name"
                    @input="onChangeGpfBuddyOptions('department')"
                  ></multiselect>
                </div>
              </div>
            </v-flex>
            <v-flex xs3 class="px-1">
              <div class="form-control">
                <div class="primary--text caption">{{ $t('position') }}</div>
                <div>
                  <multiselect
                    :disabled="
                      intent.gpf_company_code && intent.gpf_company_code.company_code === 'All'
                    "
                    v-model="intent.gpf_position_code"
                    :options="gpfPositionOptions"
                    :allow-empty="false"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                    track-by="position_code"
                    label="position_name"
                  ></multiselect>
                </div>
              </div>
            </v-flex>
            <v-flex xs3 class="px-1 pt-2">
              <div class="form-control">
                <div class="primary--text caption">{{ $t('gpf_year') }}</div>
                <div>
                  <multiselect
                    v-model="intent.gpf_years"
                    :options="gpfYearOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                    placeholder="ทั้งหมด"
                  ></multiselect>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </template>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            />
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <template>
          <div
            style="margin-top: 25px"
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless>
              <v-tab v-if="showAdvancedMenu('customer')" key="customer" href="#customer" ripple>{{
                $t('Customer')
              }}</v-tab>
              <v-tab
                v-if="!isCommentToInbox && !isLiveStream && showAdvancedMenu('context')"
                key="context"
                href="#context"
                ripple
              >
                {{ $t('Context') }}
              </v-tab>
              <v-tab
                v-if="showAdvancedMenu('timer')"
                v-show="!livechat"
                key="timer"
                href="#timer"
                ripple
                >{{ $t('Timer') }}</v-tab
              >
              <v-tab
                v-if="showAdvancedMenu('line_notify')"
                v-show="!livechat"
                key="line_notify"
                href="#line_notify"
                ripple
                >{{ $t('Line Notify') }}</v-tab
              >
              <v-tab
                key="limit_reply_to_inbox"
                href="#limit_reply_to_inbox"
                v-if="showAdvancedMenu('limit_reply_to_inbox')"
                v-show="
                  false &&
                  isCommentToInbox &&
                  !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                "
                ripple
                >{{ $t('Limit reply to inbox') }}</v-tab
              >
              <v-tab
                key="intent_group"
                href="#intent_group"
                ripple
                v-if="showIntentGroup && !livechat"
              >
                {{ $t('Intent Group') }}
              </v-tab>

              <v-tab
                v-if="showAdvancedMenu('follow_up')"
                key="follow_up"
                href="#follow_up"
                ripple
                >{{ $t('Follow Up') }}</v-tab
              >
            </v-tabs>
            <div v-show="advancedTab == 'customer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="form-control">
                    <div class="primary--text caption">{{ $t('Status') }}</div>
                    <v-layout wrap>
                      <v-flex sm11>
                        <multiselect
                          :options="statusOptions"
                          v-model="intent.userstatus"
                          :multiple="false"
                          :taggable="true"
                          @tag="onSelectStatus"
                        >
                        </multiselect>
                      </v-flex>
                      <v-flex sm1>
                        <v-btn color="primary" samll icon @click="intent.userstatus = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <div class="primary--text caption mb-2">{{ $t('Tag') }}</div>
                    <tags
                      v-if="tagOptions"
                      :combobox="true"
                      v-model="usertag"
                      :tags="usertags"
                      @tags-changed="addUserTags"
                      @before-adding-tag="checkUserTags"
                      :itemOption="tagOptions"
                      style="margin-bottom: 5px"
                      :btnText="$t('Add tag')"
                    ></tags>
                    <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!isCommentToInbox && !isLiveStream" v-show="advancedTab == 'context'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-layout>
                    <v-flex
                      class="form-control pr-1"
                      :class="{ 'has-error': errors.has('context_in') }"
                    >
                      <template v-if="isLiveStream">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('facebooklive')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else-if="isCommentToInbox">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('Comment')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else>
                        <input
                          style="margin-bottom: 5px"
                          type="text"
                          class="form-control"
                          placeholder="Context In"
                          data-vv-as="Context In"
                          name="context_in"
                          v-model="intent.context_in"
                          v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                        />
                        <span class="text-error" v-show="errors.has('context_in')">{{
                          $t('Context In cannot be Comment')
                        }}</span>
                      </template>
                    </v-flex>
                    <v-flex class="form-control pl-1">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Context Out"
                        v-model="intent.context_out"
                      />
                    </v-flex>
                  </v-layout>
                  <div class="caption">
                    {{ $t('Learn more') }}
                    <a
                      href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ $t('click here') }}</a
                    >
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-show="advancedTab == 'timer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-radio-group @change="changeOnlytime" v-model="intent.onlytime">
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Selecting certain chatbot's answers for the certain time`)"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                  <v-layout v-if="intent.onlytime">
                    <v-flex class="pr-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <v-menu
                              ref="openStartTime"
                              v-model="openStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="startTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-model="startTime"
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openStartTime"
                                v-model="startTime"
                                full-width
                                @click:minute="$refs.openStartTime.save(startTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <v-menu
                              ref="openEndTime"
                              v-model="openEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="endTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-model="endTime"
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openEndTime"
                                v-model="endTime"
                                full-width
                                @click:minute="$refs.openEndTime.save(endTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else>
                    <v-flex class="pr-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            xs6
                            class="form-control"
                            :class="{ 'has-error': errors.has('startdate') }"
                          >
                            <v-menu
                              ref="openStartDate"
                              v-model="openStartDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  v-model="startDate"
                                  v-on="on"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="startDate"
                                @input="openStartDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <v-menu
                              ref="openStartTime"
                              v-model="openStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="startTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :disabled="startDate == null"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-model="startTime"
                                  v-on="on"
                                  :disabled="startDate == null"
                                />
                              </template>
                              <v-time-picker
                                v-if="openStartTime"
                                v-model="startTime"
                                full-width
                                @click:minute="$refs.openStartTime.save(startTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            class="form-control"
                            xs6
                            :class="{ 'has-error': errors.has('enddate') }"
                          >
                            <v-menu
                              ref="openEndDate"
                              v-model="openEndDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  v-model="endDate"
                                  v-on="on"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="endDate"
                                @input="openEndDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <v-menu
                              ref="openEndTime"
                              v-model="openEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="endTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :disabled="endDate == null"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-model="endTime"
                                  v-on="on"
                                  :disabled="endDate == null"
                                />
                              </template>
                              <v-time-picker
                                v-if="openEndTime"
                                v-model="endTime"
                                full-width
                                @click:minute="$refs.openEndTime.save(endTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>

                  <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                    <input
                      v-model="startTimeFormat"
                      type="hidden"
                      :data-vv-as="$t('Start date')"
                      name="startdate"
                      v-validate="endTimeFormat ? '' : ''"
                    />
                    <input
                      :data-vv-as="$t('End date')"
                      name="enddate"
                      v-model="endTimeFormat"
                      type="hidden"
                      ref="beforeTarget"
                    />

                    <span class="text-error" v-if="errors.has('startdate')">
                      {{ errors.first('startdate') }}
                    </span>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-show="advancedTab == 'line_notify'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="col s8">
                    <div class="primary--text caption">{{ $t('Line Notify') }}</div>
                  </div>
                  <div class="col s4 right-align">
                    <template v-if="$store.state.linenotifylist.length == 0"></template>
                    <template
                      v-if="
                        [
                          'ticket',
                          'ticket2',
                          'studio7',
                          'ustore',
                          'tdtawandang',
                          'cityfresh'
                        ].includes(selectedBot.theme) ||
                        $store.state.ticketPageid.includes(selectedBot.pageid) ||
                        (['gpf', 'mtc'].includes(selectedBot.type) &&
                          ((selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)))
                      "
                    >
                      <label
                        class="toggle-switch small"
                        style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          :checked="intent.linenoti_status"
                          @change="toggleLineNotifyStatus"
                        />
                        <span class="toggle-slider lever round"></span>
                      </label>
                    </template>
                  </div>
                  <div class="col s12 form-control">
                    <template v-if="$store.state.linenotifylist.length == 0">
                      {{ $t('You are not connected to Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                        (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Message')"
                        maxlength="250"
                        v-model="intent.linenoti_text"
                      />
                    </template>
                    <template v-else>
                      {{ $t('Not yet alert via Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-show="advancedTab == 'limit_reply_to_inbox'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div
                    class="py-1 px-3 info white--text caption"
                    style="border-radius: 25px; display: inline-block"
                  >
                    ฟีเจอร์นี้ยังอยู่ในระหว่างการทดลอง Beta เปิดให้ใช้งานชั่วคราว
                  </div>

                  <div class="col s12 form-control">
                    <v-checkbox
                      v-model="isremainingreply"
                      color="primary"
                      :label="$t('Reply to comment (amount)')"
                      hide-details
                      @change="changeRemainingReply"
                    ></v-checkbox>
                    <input
                      type="number"
                      class="mt-2"
                      v-model="remaining_reply"
                      :disabled="!isremainingreply"
                      :placeholder="$t('Amount2')"
                    />
                    <v-checkbox
                      v-model="notreplysameperson"
                      color="primary"
                      :label="$t('Reply once/person')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-show="advancedTab == 'intent_group'">
              <v-card flat>
                <v-card-text>
                  <template v-if="showAdvancedIntentGroup">
                    <div>
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          sm6
                          class="form-control px-1 pb-2"
                          :class="{ 'has-error': errors.has('group') }"
                        >
                          <div class="caption mb-1 mt-2">Group *</div>
                          <multiselect
                            v-model="ticket.group"
                            :options="agentGroup"
                            track-by="groupname"
                            label="groupname"
                            name="group"
                            :searchable="true"
                            selectLabel
                            selectedLabel
                            deselect-label
                            @input="onChangeGroup"
                          ></multiselect>
                          <p class="text-error" v-if="errors.has('group')">
                            {{ errors.first('group') }}
                          </p>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.group">
                          <div class="caption mb-1 mt-2">Subgroup</div>
                          <v-layout>
                            <multiselect
                              v-model="ticket.subgroup"
                              :options="filterSubGroup"
                              track-by="subgroupname"
                              label="subgroupname"
                              :searchable="true"
                              selectLabel
                              selectedLabel
                              deselect-label
                            ></multiselect>
                            <v-btn small flat fab class="my-0" @click="ticket.subgroup = null">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <div class="caption mb-1 mt-2">Priority *</div>
                          <multiselect
                            class="mb-3"
                            v-model="ticket.priority"
                            :key="`priority`"
                            :options="priorityOptions"
                            label="text"
                            selectLabel
                            selectedLabel
                            :allow-empty="false"
                            :searchable="false"
                            deselect-label
                            track-by="text"
                          ></multiselect>
                        </v-flex>
                        <v-flex xs12>
                          <div class="caption mb-1 mt-2">Tags</div>
                          <template v-if="selectedBot.theme == 'toa'">
                            <TagManagement
                              v-model="ticket.tags"
                              :items="ticketTagsFull"
                              :filter="tagsfilter"
                            />
                          </template>
                          <v-combobox
                            v-else
                            v-model="ticket.tags"
                            :filter="tagsfilter"
                            :hide-no-data="!tagssearch"
                            :items="tagitems"
                            :search-input.sync="tagssearch"
                            hide-selected
                            label="Search for an option"
                            multiple
                            small-chips
                            solo
                          >
                            <template v-slot:no-data>
                              <v-list-tile>
                                <span class="subheading">Create</span>
                                <v-chip :color="`primary lighten-3`" label small>{{
                                  tagssearch
                                }}</v-chip>
                              </v-list-tile>
                            </template>
                            <template v-slot:selection="{ item, parent, selected }">
                              <v-chip
                                v-if="item === Object(item)"
                                :color="`primary lighten-3`"
                                :selected="selected"
                                label
                                small
                              >
                                <span class="pr-2">{{ item.text }}</span>
                                <v-icon small @click="parent.selectItem(item)">close</v-icon>
                              </v-chip>
                            </template>
                            <template v-slot:item="{ index, item }">
                              <v-list-tile-content>
                                <v-text-field
                                  v-if="tagediting === item"
                                  v-model="tagediting.text"
                                  autofocus
                                  flat
                                  background-color="transparent"
                                  hide-details
                                  solo
                                  @keyup.enter="tagsedit(index, item)"
                                ></v-text-field>
                                <v-chip v-else :color="`primary lighten-3`" label small>{{
                                  item.text
                                }}</v-chip>
                              </v-list-tile-content>
                              <v-spacer></v-spacer>
                              <v-list-tile-action @click.stop>
                                <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                                  <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </template>
                          </v-combobox>
                        </v-flex>
                      </v-layout>
                      <div>Due Date</div>
                      <v-divider></v-divider>
                      <v-layout wrap style="margin-top: 24px">
                        <v-flex xs4 class="px-1 form-control">
                          <div class="caption">Day</div>
                          <input
                            @input="ticket.day = numberOnly($event, 'day')"
                            placeholder="Days"
                            v-model.number="ticket.day"
                            type="text"
                          />
                        </v-flex>
                        <v-flex xs4 class="px-1 form-control">
                          <div class="caption">Hour</div>
                          <input
                            @input="ticket.hour = numberOnly($event, 'hour')"
                            placeholder="Hour"
                            v-model.number="ticket.hour"
                            type="text"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          class="px-1 form-control"
                          :class="{ 'has-error': errors.has('Minute') }"
                        >
                          <div class="caption">Minute</div>
                          <input
                            name="Minute"
                            @input="ticket.minute = numberOnly($event, 'minute')"
                            placeholder="Minute"
                            v-validate="'max_value:59'"
                            v-model.number="ticket.minute"
                            type="text"
                          />
                          <p class="text-error" v-if="errors.has('Minute')">
                            {{ errors.first('Minute') }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      <div class="form-control">
                        <div class="primary--text caption">{{ $t('Intent Group') }}</div>
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('Intent Group')"
                          v-model="intent.intentgroup"
                          maxlength="600"
                        />
                      </div>
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </div>
            <div v-show="advancedTab == 'follow_up'">
              <v-card flat>
                <v-card-text>
                  <template v-if="intent">
                    <FollowUpMessages
                      :intent="intent"
                      :tab="tab"
                      :isReplyComment="isReplyComment"
                      :isCommentToInbox="isCommentToInbox"
                      :isWelcome="isWelcome"
                      :timestamp="timestamp"
                      @changeSetting="changeFollowUpSetting"
                      :statusOptions="statusOptions"
                      :tagOptions="tagOptions"
                    />
                  </template>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <template>
          <input
            type="hidden"
            v-model="intent.q_val"
            v-validate="
              !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
              !hideQuestion
                ? 'required'
                : ''
            "
            :data-vv-as="$t('customer says')"
            name="q_val"
          />

          <div class="form-control has-error" style="margin-bottom: 10px">
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
            <span class="text-error" v-else-if="errors.has('q_val')">{{
              errors.first('q_val')
            }}</span>
            <span class="text-error" v-else-if="errors.has('bubbleLimit')">{{
              errors.first('bubbleLimit')
            }}</span>
            <span class="text-error" v-else-if="errorTag.length > 0">
              <template v-if="errorTag.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorTag.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorTag.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
            <span class="text-error" v-else-if="errorUserTags.length > 0">
              <template v-if="errorUserTags.includes('duplicate')">{{
                $t('Duplicate Tag')
              }}</template>
            </span>

            <span class="text-error" v-else-if="errors.has('context_in')">{{
              $t('Context In cannot be Comment')
            }}</span>
            <span class="text-error" v-else-if="errors.has('startdate')">{{
              errors.first('startdate')
            }}</span>
          </div>
          <slot name="footer" :saveIntent="saveIntent" :cancelEdit="cancelEdit">
            <div style="margin-bottom: 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <em class="far fa-eye" />
                {{ $t('preview') }}
              </a>
              <preview-message
                v-if="showPreview"
                @close="showPreview = false"
                :messages="previewMessage"
                :choice="replies"
                :questions="questions"
                :isComment="isCommentToInbox"
                :comment="replyComment"
              ></preview-message>
            </div>
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn v-if="ticket2showsave" depressed color="primary" @click="saveIntent">{{
              $t('Save')
            }}</v-btn>
            <v-btn dark v-if="livechat" depressed color="#366cd1" @click="sendToLivechat">{{
              $t('Send')
            }}</v-btn>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import GenericManage from '@/components/elements/GenericManage'
import ModalBlank from '@/components/elements/ModalBlank'
import ModalDialog from '@/components/elements/ModalDialog'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import PreviewMessage from '@/components/elements/PreviewMessage'
import Tags from '@/components/elements/Tags'
import uploadfile from '@/components/elements/uploadfile'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import VueTagsInput from '@johmun/vue-tags-input'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { VueAutosuggest } from 'vue-autosuggest'
import { ToggleButton } from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'
import Draggable from 'vuedraggable'
import datepicker from 'vuejs-datepicker'
import { mapGetters } from 'vuex'
import FollowUpMessages from './FollowUpMessages'
import IntentComment from './IntentComment'
import IntentGetstarted from './IntentGetstarted'
import IntentGroup from './IntentGroup'
import IntentPrefill from './IntentPrefill'
import IntentQuestion from './IntentQuestion'
import IntentSelectPost from './IntentSelectPost'
import IntentSelectPostLabel from './IntentSelectPostLabel'
import ticketApi from '@/api/ticket'
import { handleResponse, handleApiError } from '@/api/util'
import { PAGE } from '@/constants/page.js'
import TagManagement from '@/components/view/ticket/TagManagement'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    excludedIntentName: {
      type: String,
      default: ''
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    },
    isLiveStream: {
      type: Boolean,
      default: false
    },
    livechat: {
      type: Boolean,
      default: false
    },
    hideQuestion: {
      default: false
    },
    hideSetting: {
      default: false
    },
    hidePriority: {
      default: false
    },
    readonlyName: {
      default: false
    },
    hideAdvanceOptions: {
      default: null
    },
    availableBubbles: {},

    hideChoice: {
      default: false
    },
    hideStatus: {
      default: false
    }
  },
  components: {
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentComment,
    IntentGetstarted,
    Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,

    ModalDialog,
    ModalBlank,
    Tags,
    PreviewMessage,
    ViewCartSummaryViewer,
    VueAutosuggest,
    IntentSelectPost,
    IntentQuestion,
    Multiselect,
    ToggleButton,
    datepicker,
    IntentSelectPostLabel,
    FollowUpMessages,
    TagManagement
  },
  data: function () {
    return {
      statusOptions: [],
      tagOptions: null,
      tagssearch: null,
      showDueTimeDialog: false,
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      tab: 'all',
      showMultipleChannel: false,
      tagediting: null,
      postidlist: { includes: [], excludes: [], post_keywords: [] },
      advancedTab: null,
      showSelectPost: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      reply: '',
      text: '',
      messages: [[]],
      fb_messages: [[]],
      line_messages: [[]],
      ig_messages: [[]],

      errorTag: [],
      errorUserTags: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],
      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10,
      isremainingreply: false,
      remaining_reply: null,
      notreplysameperson: false,
      ticket: {
        assigngroupid: '',
        assignsubgroupid: '',
        priority: '',
        group: '',
        subgroup: '',
        tags: [],
        day: 0,
        hour: 0,
        minute: 0,
        duedate: {
          start: '',
          starttime: '',
          end: ''
        }
      },
      tagitems: [{ header: 'Select an option or create one' }],
      limit: 10,
      showDueDate: false,
      timestamp: moment().format('x'),
      isShowIntentGroup: false,
      positionOptions: [],
      affiliationOptions: [],
      showMultipleChannelFollowUp: false,
      gpfBuddyOption: {
        positions: [],
        companies: [],
        departments: [],
        groups: []
      },
      gpfYearOptions: ['ก่อน พ.ศ.2555', 'หลัง พ.ศ.2555']
    }
  },
  created: function () {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field, val) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate(value, field) {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = moment(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      }
    })
  },
  async mounted() {
    let vm = this
    vm.getUserStatusList()
    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)
    vm.intent = Object.assign({}, vm.value)

    this.not_reply_within_seconds = this.MinuteToSecond(this.intent.not_reply_within_seconds)

    if (typeof this.intent.follow_up_within_seconds !== 'object') {
      this.intent.follow_up_within_seconds = {
        HH: ('0' + Math.floor(parseInt(this.intent.follow_up_within_seconds) / 60 / 60)).slice(-2),
        mm: (
          '0' + JSON.stringify((parseInt(this.intent.follow_up_within_seconds) / 60) % 60)
        ).slice(-2)
      }
    }

    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }
    if (vm.intent.fb_val || vm.intent.line_val || vm.intent.ig_val) {
      this.showMultipleChannel = true

      this.fb_messages = JSON.parse(vm.intent.fb_val) || [[]]
      this.line_messages = JSON.parse(vm.intent.line_val) || [[]]
      this.ig_messages = JSON.parse(vm.intent.ig_val) || [[]]
      this.tab = 'facebook'
    }

    const hasMultipleChannel = this.$store.state.socialChannelOptions.find((social) => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
        this.intent[`follow_up_${social.value}_val`]
      )
    })
    if (hasMultipleChannel) {
      this.showMultipleChannelFollowUp = true
    }

    this.timestamp = moment().format('x')

    if (vm.isCommentToInbox) {
      vm.remaining_reply = vm.intent.remaining_reply
      vm.notreplysameperson = vm.intent.notreplysameperson
      vm.isremainingreply = vm.intent.remaining_reply != null
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }
    if (!vm.intent.post_keywords) {
      vm.intent.post_keywords = ''
    } else {
      var post_keywords = []
      if (vm.intent.post_keywords && vm.intent.post_keywords !== '') {
        try {
          post_keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {}
      }
      this.$set(this.postidlist, 'post_keywords', post_keywords)
    }
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime = vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      $.each(names, function (index, name) {
        if (name === vm.intent.intentname) {
          names.splice(index, 1)
          return false
        }
      })

      names = names.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function (index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function (index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              if (messageParsed.buttons) {
                messageParsed.buttons = messageParsed.buttons.filter(Boolean)
              }
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square'
            }
          ]
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
    if (
      ['ticket', 'ticket2', 'studio7', 'ustore', 'tdtawandang', 'cityfresh'].includes(
        this.selectedBot.theme
      ) ||
      [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
        this.selectedBot.pageid
      ) ||
      ['gpf', 'mtc'].includes(this.selectedBot.type)
    ) {
      this.ticketinit()
    }
    if (
      this.livechat &&
      (['ticket2', 'studio7', 'ustore', 'tdtawandang'].includes(this.selectedBot.theme) ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
        this.$store.state.toaPaintPage.includes(this.selectedBot.pageid)) &&
      this.type == 'add'
    ) {
      this.intent.q_val = 'exacts(intent_type_quick_message)'
    }

    if (['mitsuwebchat'].includes(this.selectedBot.theme)) {
      try {
        if (vm.$store.state.privilege.role == 'superadmin') {
          if (vm.intent.intentgroup) {
            let currentGroup = this.agentGroup.find((el) => el.id == vm.intent.intentgroup)
            this.$set(this.intent, 'intentgroup', currentGroup)
          } else {
            // vm.intent.intentgroup = '';
            this.$set(this.intent, 'intentgroup', '')
          }
        } else {
          let admingroupid = this.$store.state.admingroupid
          let currentGroup = this.agentGroup.find((el) => el.id == admingroupid)
          this.$set(this.intent, 'intentgroup', currentGroup)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (!vm.$store.state.tags) {
      const tags = await vm.getUserTagList()
      vm.$store.state.tags = tags || []
    }
    this.tagOptions = this.$store.state.tags || []

    if (vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)) {
      if (vm.intent.group_conversation_id) {
        let groupConversationId = vm.intent.group_conversation_id
        let selectedConversationGroup = this.groupConversation.find(
          (el) => el.id == groupConversationId
        )
        this.$set(this.intent, 'group_conversation_id', selectedConversationGroup)
      } else {
        var group = [{ id: 'all', name: 'All', status: true }]
        this.$set(this.intent, 'group_conversation_id', group)
      }
    }

    if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
      let tempPositionOptions = []
      tempPositionOptions.push({ id: 0, engname: 'All', thname: 'All' })
      tempPositionOptions.push(...vm.$store.state.hopinnMasterData.position)
      vm.positionOptions = tempPositionOptions

      let tempAffiliationOptions = []
      tempAffiliationOptions.push({ id: 0, engname: 'All', thname: 'All' })
      tempAffiliationOptions.push(...vm.$store.state.hopinnMasterData.affiliation)
      vm.affiliationOptions = tempAffiliationOptions

      // vm.positionOptions = vm.$store.state.hopinnMasterData.position
      // vm.affiliationOptions = vm.$store.state.hopinnMasterData.affiliation

      if (vm.intent.custom_filter_2) {
        let current = vm.positionOptions.find((el) => el.engname == vm.intent.custom_filter_2)
        vm.$set(vm.intent, 'custom_filter_2', current)
      } else {
        vm.$set(vm.intent, 'custom_filter_2', { id: 0, engname: 'All', thname: 'All' })
      }

      if (vm.intent.custom_filter_1) {
        let current = vm.affiliationOptions.find((el) => el.engname == vm.intent.custom_filter_1)
        vm.$set(vm.intent, 'custom_filter_1', current)
      } else {
        vm.$set(vm.intent, 'custom_filter_1', { id: 0, engname: 'All', thname: 'All' })
      }
    }

    if (vm.isGpfBuddy) {
      this.handleInitialGpfBuddy()
    }
  },
  computed: {
    showAdvancedIntentGroup() {
      return (
        ['ticket', 'ticket2', 'studio7', 'ustore', 'tdtawandang', 'cityfresh', 'nestle'].includes(
          this.selectedBot.theme
        ) ||
        [
          ...this.$store.state.ticketPageid,
          ...this.$store.state.rabbitReplyFBPostPage,
          ...this.$store.state.toaPaintPage
        ].includes(this.selectedBot.pageid) ||
        ['gpf', 'mtc'].includes(this.selectedBot.type)
      )
    },
    showIntentGroup() {
      return (
        (!this.isCommentToInbox &&
          this.$store.getters.showIntentGroup &&
          this.showAdvancedMenu('intent_group')) ||
        (this.isCommentToInbox &&
          [...this.$store.state.oceanlifePage, ...this.$store.state.rabbitReplyFBPostPage].includes(
            this.selectedBot.pageid
          ))
      )
    },
    previewMessage() {
      let messagevalue = this.messages
      if (this.tab == 'line' && this.line_messages && this.line_messages.length) {
        messagevalue = this.line_messages
      } else if (this.tab == 'facebook' && this.fb_messages && this.fb_messages.length) {
        messagevalue = this.fb_messages
      }
      return messagevalue
    },
    ticket2showsave() {
      return !this.livechat || this.intent.q_val === 'exacts(intent_type_quick_message)'
    },
    // tickettags() {
    //   return this.ticket.tags
    // },
    isReadonly() {
      if (
        this.selectedBot.theme == 'tero' &&
        this.type === 'edit' &&
        (this.intent.intentname.includes('Answer__') ||
          this.intent.intentname.includes('Question__') ||
          this.intent.intentname.includes('Comment__'))
      ) {
        return true
      } else {
        return false
      }
    },
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    showReplyCommentSelectPost() {
      return this.isReplyComment && this.isCommentToInbox && !this.isLiveStream
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      ticketTags: 'ticketTags',
      ticketTagsFull: 'ticketTagsFull',
      setting: 'setting',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup'
    }),
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.tab)
      return messages
    },

    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },

    groupConversation: function () {
      var group = [{ id: 'all', name: 'All', status: true }]
      var groupConversation = this.$store.state.groupConversation
      group.push(...groupConversation)
      return group
    },

    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          try {
            result = tags(function (val) {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map(function (val) {
            return val.text
          })
        } catch (error) {}
        vm.intent.q_val = result.join(',')
      }
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'quick_reply', result.join(','))
      }
    },
    fb_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.fb_quick_reply && vm.intent.fb_quick_reply !== '') {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'fb_quick_reply', result.join(','))
      }
    },
    line_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.line_quick_reply && vm.intent.line_quick_reply !== '') {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'line_quick_reply', result.join(','))
      }
    },
    ig_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.ig_quick_reply && vm.intent.ig_quick_reply !== '') {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'ig_quick_reply', result.join(','))
      }
    },

    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'usertags', result.join(','))
      }
    },
    questions: function () {
      var result = []
      try {
        var questions = this.formatQuestionData(this.intent.q_val)
        // console.log(questions)
        if (questions.normal) {
          result = questions.normal.map((el) => {
            return el.text
          })
        } else if (questions.keyword) {
          result = questions.keyword.map((el) => {
            return el.text
          })
        } else if (questions.exactly) {
          result = questions.exactly.map((el) => {
            return el.text
          })
        } else if (questions.startwith) {
          result = questions.startwith.map((el) => {
            return el.text
          })
        } else if (questions.endwith) {
          result = questions.endwith.map((el) => {
            return el.text
          })
        } else if (questions.startandendwith) {
          result = questions.startandendwith.map((el) => {
            return el.text
          })
        }
        // result = questions.map(function(val) {
        //   return val.text
        // })
      } catch (error) {
        console.log(error)
      }
      return result
    },
    startTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.startTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.startTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 00:00:00'
      } else if (vm.startDate) {
        if (vm.startTime) {
          time = vm.startDate + ' ' + vm.startTime + ':00'
        } else {
          time = vm.startDate + ' 00:00:00'
        }
      }
      return time
    },
    endTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.endTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.endTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 23:59:00'
      } else if (vm.endDate) {
        if (vm.endTime) {
          time = vm.endDate + ' ' + vm.endTime + ':00'
        } else {
          time = vm.endDate + ' 23:59:00'
        }
      }
      return time
    },
    intentgroup() {
      var hasValue = (val) => (val && val.length ? val : null)
      var duedate = null
      if (this.ticket.duedate.start) {
        duedate = moment(this.ticket.duedate.start).format('YYYY-MM-DD')
        if (this.ticket.duedate.starttime) {
          duedate = duedate + ' ' + this.ticket.duedate.starttime
        } else {
          duedate = duedate + ' 00:00'
        }
      }
      return {
        assigngroupid: hasValue(this.ticket.group ? this.ticket.group.id : null),
        assignsubgroupid: hasValue(this.ticket.subgroup ? this.ticket.subgroup.id : null),
        priority: hasValue(this.ticket.priority ? this.ticket.priority.value : null),
        duedate: duedate,
        day: this.ticket.day ? this.ticket.day : null,
        hour: this.ticket.hour ? this.ticket.hour : null,
        minute: this.ticket.minute ? this.ticket.minute : null,

        tags:
          this.ticket.tags && this.ticket.tags.length
            ? this.ticket.tags.map((el) => el.name).join(',')
            : null
      }
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData || []
    },
    gpfCompanyOptions() {
      const tempMapCompany = this.gpfBuddyMasterData.companies
        ? this.gpfBuddyMasterData.companies.map((el) => {
            return {
              company_code: el.company_code,
              company_name: `${el.company_code} - ${el.company_name}`
            }
          })
        : []
      return [{ company_code: 'All', company_name: 'ทั้งหมด' }, ...tempMapCompany] || []
    },
    gpfGroupOptions() {
      const allGroups = this.gpfBuddyMasterData.groups || []

      let tempOptions = []
      if (this.intent.gpf_company_code && this.intent.gpf_company_code.company_code !== 'All') {
        const selectedCompanyCode = this.intent.gpf_company_code.company_code
        const filterGroup = allGroups
          .filter((el) => {
            return el.company_code === selectedCompanyCode
          })
          .map((el) => {
            return {
              group_code: el.group_code,
              group_name: `${el.group_code} - ${el.group_name}`
            }
          })

        tempOptions = [{ group_code: 'All', group_name: 'ทั้งหมด' }, ...filterGroup]
      } else {
        tempOptions = [{ group_code: 'All', group_name: 'ทั้งหมด' }, ...allGroups]
      }
      return tempOptions
    },
    gpfDepartmentOptions() {
      const allDepartments = this.gpfBuddyMasterData.departments || []
      let tempOptions = []

      if (this.intent.gpf_company_code && this.intent.gpf_company_code.company_code !== 'All') {
        const selectedCompanyCode = this.intent.gpf_company_code.company_code || []
        let tempResult = []
        const tempFilterDepartments = allDepartments.filter((el) => {
          return el.company_code === selectedCompanyCode
        })

        tempResult = tempFilterDepartments || []

        if (this.intent.gpf_group_code && this.intent.gpf_group_code.group_code !== 'All') {
          const selectedGroupCode = this.intent.gpf_group_code.group_code
          const filterDepartmentByGroup = tempFilterDepartments.filter((el) => {
            return el.group_code === selectedGroupCode
          })

          tempResult = filterDepartmentByGroup
        }


        let tempMapDepartment = []
        tempResult.forEach((el) => {
          if (!tempMapDepartment.some((item) => item.department_code === el.department_code)) {
            tempMapDepartment.push({
              department_code: el.department_code,
              department_name: `${el.department_code} - ${el.department_name}`
            })
          }
        })

        tempOptions = [{ department_code: 'All', department_name: 'ทั้งหมด' }, ...tempMapDepartment]
      } else {
        tempOptions = [{ department_code: 'All', department_name: 'ทั้งหมด' }, ...allDepartments]
      }

      return tempOptions
    },
    gpfPositionOptions() {
      const allPositions = this.gpfBuddyMasterData.positions || []
      let tempOptions = []

      if (this.intent.gpf_company_code && this.intent.gpf_company_code.company_code !== 'All') {
        const selectedCompanyCode = this.intent.gpf_company_code.company_code
        let tempResult = []
        const tempFilterPositions = allPositions.filter((el) => {
          return el.company_code === selectedCompanyCode
        })

        tempResult = tempFilterPositions || []

        if (this.intent.gpf_group_code && this.intent.gpf_group_code.group_code !== 'All') {
          const selectedGroupCode = this.intent.gpf_group_code.group_code
          const filterPositionByGroup = tempFilterPositions.filter((el) => {
            return el.group_code === selectedGroupCode
          })
          tempResult = filterPositionByGroup
        }

        if (
          this.intent.gpf_department_code &&
          this.intent.gpf_department_code.department_code !== 'All'
        ) {
          const selectedDepartmentCode = this.intent.gpf_department_code.department_code
          const filterPositionByGroup = tempFilterPositions.filter((el) => {
            return el.department_code === selectedDepartmentCode
          })
          tempResult = filterPositionByGroup
        }

        let tempMapPositions = []
        tempResult.forEach((el) => {
          if (!tempMapPositions.some((item) => item.position_code === el.position_code)) {
            tempMapPositions.push({
              position_code: el.position_code,
              position_name: `${el.position_code} - ${el.position_name}`
            })
          }
        })

        tempOptions = [{ position_code: 'All', position_name: 'ทั้งหมด' }, ...tempMapPositions]
      } else {
        tempOptions = [{ position_code: 'All', position_name: 'ทั้งหมด' }, ...allPositions]
      }

      return tempOptions
    }
  },

  methods: {
    showAdvancedMenu(type) {
      if (this.hideAdvanceOptions) {
        return !this.hideAdvanceOptions.includes(type)
      } else {
        return true
      }
    },
    changeFollowUpSetting(setting) {
      this.showMultipleChannelFollowUp = setting.showMultipleChannel || false
    },
    onSelectStatus(value) {
      this.intent.userstatus = value
    },
    async getUserTagList(query) {
      var response = await api.getUserTagList({
        limit: 100,
        offset: 0,
        filter_name: query || undefined
      })
      if (response && response.result) {
        return response.result.map((item) => {
          return item.name
        })
      } else {
        return []
      }
    },
    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    async changeSetting(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          this.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          if (this.isWelcome) {
            try {
              await this.$nextTick()
              let { messages } = this.$store.getters.welcomeMessage('all')
              var fb_messages = cloneDeep(messages)
              this.fb_messages = fb_messages.map((el) => {
                return el.filter((sel) => {
                  return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                }, [])
              }, [])

              this.line_messages = cloneDeep(messages)
              this.ig_messages = cloneDeep(messages)
              this.ig_messages = this.ig_messages.map((el) => {
                return el.filter((sel) => {
                  return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                }, [])
              }, [])
            } catch (error) {
              console.log(error)
            }
          } else {
            var fb_messages = cloneDeep(this.messages)
            this.fb_messages = fb_messages.map((el) => {
              return el.filter((sel) => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            this.line_messages = cloneDeep(this.messages)
            this.ig_messages = cloneDeep(this.messages)
            this.ig_messages = this.ig_messages.map((el) => {
              return el.filter((sel) => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])

            this.$set(this.intent, 'fb_quick_reply', this.intent.quick_reply)
            this.$set(this.intent, 'line_quick_reply', this.intent.quick_reply)
            this.$set(this.intent, 'ig_quick_reply', this.intent.quick_reply)
          }
        }
        this.showMultipleChannel = payload.showMultipleChannel

        if (this.showMultipleChannel) this.tab = 'facebook'
        else this.tab = 'all'
      }
    },
    changeRemainingReply(value) {
      if (value) {
        this.remaining_reply = 0
      } else {
        this.remaining_reply = null
      }
    },
    formatQuestionData: function (text) {
      var questions = text && text !== '' ? text.split(',') : []
      var result = {
        normal: [],
        keyword: [],
        exactly: [],
        startwith: [],
        endwith: [],
        startandendwith: []
      }
      if (questions) {
        questions.forEach(function (question) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.exactly.push({ text: keyword })
          } else {
            result.normal.push({ text: question })
          }
        })
      }
      return result
    },
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    ticketinit() {
      try {
        try {
          if (this.intent.intentgroup) {
            if (this.IsJsonString(this.intent.intentgroup)) {
              var ticket = JSON.parse(this.intent.intentgroup)
            } else {
              var ticket = this.intent.intentgroup
            }
            this.ticket = Object.assign(this.ticket, {
              group: ticket.assigngroupid
                ? this.agentGroup.find((el) => el.id == ticket.assigngroupid)
                : '',
              subgroup: ticket.assignsubgroupid
                ? this.agentSubGroup.find((el) => el.id == ticket.assignsubgroupid)
                : '',
              priority: ticket.priority
                ? this.priorityOptions.find((el) => el.value == ticket.priority)
                : '',
              tags: ticket.tags
                ? ticket.tags.split(',').map((el) => {
                    return { name: el }
                  })
                : []
            })
            if (ticket.duedate) {
              this.ticket.duedate = {
                start: moment(this.ticket.duedate).format('YYYY-MM-DD'),
                starttime: moment(this.ticket.duedate).format('HH:mm'),
                end: ''
              }
            }
            if (ticket.day) {
              this.ticket.day = ticket.day
            }
            if (ticket.hour) {
              this.ticket.hour = ticket.hour
            }
            if (ticket.minute) {
              this.ticket.minute = ticket.minute
            }
          }
        } catch (error) {
          console.log(error)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async tagsedit(index, item) {
      this.showEditTicketTag = !this.showEditTicketTag
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        //save tag
        const result = await this.handleEditTicketTag(item, this.tagediting)
        if (result) {
          //clear tag
          const tagIndex = this.ticketTagsFull.findIndex((el) => el.id != item.id)
          if (tagIndex != -1) {
            const tags = this.ticketTagsFull
            tags[tagIndex] = this.tagediting
            this.$store.commit('SET_TICKET_TAGS_FULL', tags)
          }
          this.tagediting = null
          this.index = -1
        }
      }
    },
    async handleEditTicketTag(item, newVal) {
      try {
        const tag = this.ticketTagsFull.find((tag) => {
          return tag && item && tag.name.toLowerCase() == item.name.toLowerCase()
        })

        if (tag && newVal) {
          const response = await ticketApi.putEditTicketTag({
            data: { pageid: this.selectedBot.pageid, id: tag.id, ticket_tag: newVal.name }
          })
          await handleResponse(response)
          return true
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (this.ticket.duedate.end && moment(this.ticket.duedate.end).isBefore(value)) {
        this.ticket.duedate.end = value
      }
      vm.ticket.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },
    onSelectedDepartment(val) {
      this.$set(this.intent, 'intentgroup', val)
    },
    saveFilterPost(payload) {
      this.$set(this.intent, 'postidlist', payload.includes)
      this.$set(this.intent, 'exceptpostidlist', payload.excludes)
      this.$set(this.intent, 'post_keywords', payload.post_keywords)

      var includes = []
      var excludes = []
      var post_keywords = []
      if (payload.includes) {
        try {
          includes = JSON.parse(payload.includes)
        } catch (error) {
          includes = payload.includes.split(',')
        }
      }
      if (payload.excludes) {
        try {
          excludes = JSON.parse(payload.excludes)
        } catch (error) {
          excludes = payload.excludes.split(',')
        }
      }
      if (payload.post_keywords) {
        try {
          post_keywords = JSON.parse(payload.post_keywords)
        } catch (error) {
          post_keywords = payload.post_keywords.split(',')
        }
      }
      this.postidlist = { includes, excludes, post_keywords }
    },
    changeOnlytime(e) {
      this.$forceUpdate()
    },
    toggleLineNotifyStatus: function () {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
    },
    addGeneric: function () {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true
      })
    },
    sendToLivechat() {
      var messages = this.checkEmptyMessage(this.messages)
      var a_val = JSON.stringify(messages)
      this.$emit('sendtolivechat', { ...this.intent, a_val })
    },
    MinuteToSecond(minute) {
      var m = null
      if (typeof minute === 'string') {
        m = parseFloat(minute)
      }
      return Math.floor(m / 60) ? JSON.stringify(Math.floor(m / 60)) : null
    },
    saveIntent: function () {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        ...vm.intent,
        intentname: vm.intent.intentname.trim(),
        a_type: 'json',
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime: vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null,
        post_keywords: vm.intent.post_keywords ? vm.intent.post_keywords : '',
        follow_up_status: vm.intent.follow_up_status ? vm.intent.follow_up_status : null,
        follow_up_within_seconds: vm.intent.follow_up_within_seconds
          ? (parseInt(vm.intent.follow_up_within_seconds.HH) * 60 +
              parseInt(
                vm.intent.follow_up_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_within_seconds.mm
              )) *
            60
          : null,
        follow_up_val: this.intent.follow_up_val
          ? JSON.stringify(this.checkEmptyMessage(this.intent.follow_up_val || []))
          : null,
        follow_up_quick_reply: vm.intent.follow_up_quick_reply
          ? vm.intent.follow_up_quick_reply
          : null,
        follow_up_type: 'json'
      }
      if (vm.selectedBot.theme == 'toa') {
        // const currentTags = vm.tickettags.map((x) => x.name)
        const currentTags = vm.ticket.tags.map((el) => el.name)
        vm.$store.dispatch('updateTicketTags', currentTags)
      }
      if (vm.selectedBot.theme == 'universalutilities') {
        if (vm.selectedBot.uu_areaname != '' && vm.selectedBot.uu_areaname != null) {
          data.intentgroup = vm.selectedBot.uu_areaname
        } else if (vm.selectedBot.uu_areaname == '' || vm.selectedBot.uu_areaname == null) {
          data.intentgroup = vm.intent.intentgroup == 'ทุกพื้นที่' ? '' : vm.intent.intentgroup
        }
      } else if (
        ['ticket', 'ticket2', 'studio7', 'ustore', 'tdtawandang', 'cityfresh'].includes(
          vm.selectedBot.theme
        ) ||
        [...vm.$store.state.ticketPageid].includes(vm.selectedBot.pageid) ||
        ['gpf', 'mtc'].includes(vm.selectedBot.type)
      ) {
        data.intentgroup = vm.intentgroup
      } else if (['mitsuwebchat'].includes(vm.selectedBot.theme)) {
        data.intentgroup = vm.intent.intentgroup ? vm.intent.intentgroup.id : ''
      } else if ([...vm.$store.state.toaPaintPage].includes(vm.selectedBot.pageid)) {
        data.intentgroup = vm.intentgroup

        if (vm.intent.group_conversation_id && vm.intent.group_conversation_id.id !== 'all') {
          data.group_conversation_id = vm.intent.group_conversation_id.id
        } else {
          data.group_conversation_id = null
        }
      }

      if (this.showMultipleChannel) {
        data.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
        data.ig_val = JSON.stringify(vm.ig_messages).replace(/ /gim, ' ')
        data.fb_quick_reply = vm.intent.fb_quick_reply
        data.line_quick_reply = vm.intent.line_quick_reply
        data.ig_quick_reply = vm.intent.ig_quick_reply
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.userstatus = vm.intent.userstatus
        data.usertags = vm.intent.usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.linenoti_text = vm.intent.linenoti_text
        data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }
      if (
        ['studio7', 'ticket2', 'ustore', 'tdtawandang', 'cityfresh'].includes(
          vm.selectedBot.theme
        ) ||
        vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)
      ) {
        if (data.intentgroup && data.intentgroup.assigngroupid) {
          data.context_out = 'contactadmin'
        }
      }

      if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
        data.custom_filter_1 =
          vm.intent.custom_filter_1 && vm.intent.custom_filter_1.engname !== 'All'
            ? vm.intent.custom_filter_1.engname
            : ''
        data.custom_filter_2 =
          vm.intent.custom_filter_2 && vm.intent.custom_filter_2.engname !== 'All'
            ? vm.intent.custom_filter_2.engname
            : ''
      }

      if (vm.isGpfBuddy) {
        data.gpf_company_code =
          vm.intent.gpf_company_code && vm.intent.gpf_company_code.company_code !== 'All'
            ? vm.intent.gpf_company_code.company_code
            : null
        data.gpf_group_code =
          vm.intent.gpf_group_code && vm.intent.gpf_group_code.group_code !== 'All'
            ? vm.intent.gpf_group_code.group_code
            : null
        data.gpf_department_code =
          vm.intent.gpf_department_code && vm.intent.gpf_department_code.department_code !== 'All'
            ? vm.intent.gpf_department_code.department_code
            : null
        data.gpf_position_code =
          vm.intent.gpf_position_code && vm.intent.gpf_position_code.position_code !== 'All'
            ? vm.intent.gpf_position_code.position_code
            : null
        data.gpf_years = vm.intent.gpf_years ? vm.intent.gpf_years : null
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }

          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = vm.checkEmptyMessage(vm.messages)

          data.a_val = JSON.stringify(messages)
        }
      }
      data.follow_up_fb_val = this.showMultipleChannelFollowUp
        ? typeof vm.intent.follow_up_fb_val != 'string'
          ? JSON.stringify(vm.intent.follow_up_fb_val).replace(/ /gim, ' ')
          : vm.intent.follow_up_fb_val
        : null
      data.follow_up_line_val = this.showMultipleChannelFollowUp
        ? typeof vm.intent.follow_up_line_val != 'string'
          ? JSON.stringify(vm.intent.follow_up_line_val).replace(/ /gim, ' ')
          : vm.intent.follow_up_line_val
        : null
      data.follow_up_ig_val = this.showMultipleChannelFollowUp
        ? typeof vm.intent.follow_up_ig_val != 'string'
          ? JSON.stringify(vm.intent.follow_up_ig_val).replace(/ /gim, ' ')
          : vm.intent.follow_up_ig_val
        : null
      if (this.showMultipleChannelFollowUp) {
        data.follow_up_fb_quick_reply = vm.intent.follow_up_fb_quick_reply
        data.follow_up_line_quick_reply = vm.intent.follow_up_line_quick_reply
        data.follow_up_ig_quick_reply = vm.intent.follow_up_ig_quick_reply
      }
      vm.$validator
        .validateAll()
        .then((result) => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }

          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            api.addIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              vm.intent = cloneDeep(vm.intentTemplate())
              vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            api.editIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$emit('input', data)
              // console.log(data)
              vm.$emit('saveIntent', data)
              vm.cached_intent = Object.assign({}, vm.intent)

              vm.$store.dispatch('loading')
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    cancelEdit: function () {
      var vm = this
      vm.intent = Object.assign({}, vm.cached_intent)
      vm.$emit('close', null)
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else

      this.errorTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.type == 'add' && this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      }
      // else if (obj.tag.text.length > 20) {
      //   this.errorUserTags.push('overmaxlength')
      //   obj.error()
      // }
      else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function () {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function () {
      let intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
      this.$set(this.intent, 'intentstatus', !intentstatus)
    },
    onChangeIntentOnlyTime: function () {
      let onlytime = this.intent.onlytime ? this.intent.onlytime : false

      this.$set(this.intent, 'onlytime', !onlytime)
    },
    addIntentPrefill: function (prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition)
      ].join('')
    },
    addEmoji: function (emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function (type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function (newTags) {
      this.replies = newTags
      // console.log(newTags,this.replies)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    onSelected(option) {
      this.selected = option.item
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter((item) => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData
        }
      ]
    },
    getAdminGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSearchTag({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchTagTimeout) {
        clearTimeout(vm.updateSearchTagTimeout)
      }
      vm.updateSearchTagTimeout = setTimeout(async () => {
        try {
          const tags = await vm.getUserTagList(event)
          onComplete(tags)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchTagTimeout = null
      }, 3000)
    },
    handleInitialGpfBuddy() {
      const vm = this
      try {
        const gpfBuddyData = vm.gpfBuddyMasterData
        const companies = gpfBuddyData.companies
        const groups = gpfBuddyData.groups
        const departments = gpfBuddyData.departments
        const positions = gpfBuddyData.positions

        if (vm.intent.gpf_company_code) {
          const selectedCompany = companies
            .filter((el) => {
              return el.company_code === vm.intent.gpf_company_code
            })
            .map((el) => {
              return {
                company_code: el.company_code,
                company_name: `${el.company_code} - ${el.company_name}`
              }
            })

          vm.$set(vm.intent, 'gpf_company_code', ...(selectedCompany || []))
        } else {
          vm.$set(vm.intent, 'gpf_company_code', {
            company_code: 'All',
            company_name: 'ทั้งหมด'
          })
        }

        if (vm.intent.gpf_company_code) {
          const selectedCompanyCode = vm.intent.gpf_company_code.company_code

          if (vm.intent.gpf_group_code) {
            const groupByCompany = groups
              .filter((el) => {
                return el.company_code === selectedCompanyCode
              })
              .map((el) => {
                return {
                  group_code: el.group_code,
                  group_name: `${el.group_code} - ${el.group_name}`
                }
              })

            const selectedGroup = groupByCompany.find((el) => {
              return el.group_code === vm.intent.gpf_group_code
            })

            vm.$set(vm.intent, 'gpf_group_code', selectedGroup)
          } else {
            vm.$set(vm.intent, 'gpf_group_code', {
              group_code: 'All',
              group_name: 'ทั้งหมด'
            })
          }

          if (vm.intent.gpf_department_code) {
            const departmentByCompany = departments
              .filter((el) => {
                return el.company_code === selectedCompanyCode
              })
              .map((el) => {
                return {
                  department_code: el.department_code,
                  department_name: `${el.department_code} - ${el.department_name}`
                }
              })

            const selectedDepartment = departmentByCompany.find(
              (el) => el.department_code == vm.intent.gpf_department_code
            )

            vm.$set(vm.intent, 'gpf_department_code', selectedDepartment)
          } else {
            vm.$set(vm.intent, 'gpf_department_code', {
              department_code: 'All',
              department_name: 'ทั้งหมด'
            })
          }

          if (vm.intent.gpf_position_code) {
            const positionByCompany = positions
              .filter((el) => {
                return el.company_code === selectedCompanyCode
              })
              .map((el) => {
                return {
                  position_code: el.position_code,
                  position_name: `${el.position_code} - ${el.position_name}`
                }
              })

            const selectedPosition = positionByCompany.find(
              (el) => el.position_code == vm.intent.gpf_position_code
            )

            vm.$set(vm.intent, 'gpf_position_code', selectedPosition)
          } else {
            vm.$set(vm.intent, 'gpf_position_code', {
              position_code: 'All',
              position_name: 'ทั้งหมด'
            })
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    onChangeGpfBuddyOptions(type) {
      const vm = this
      if (type === 'company') {
        vm.$set(vm.intent, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'ทั้งหมด'
        })
        vm.$set(vm.intent, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'ทั้งหมด'
        })
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'ทั้งหมด'
        })
      } else if (type === 'group') {
        vm.$set(vm.intent, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'ทั้งหมด'
        })
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'ทั้งหมด'
        })
      } else if (type === 'department') {
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'ทั้งหมด'
        })
      }
    }
  },
  watch: {
    showPreview: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    'intent.context_in': function (newVal, oldVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    tickettags(val, prev) {
      if (val.length === prev.length) return

      this.ticket.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }
          this.$nextTick(() => {
            this.tagitems.push(v)
            this.$forceUpdate()
          })
        }

        return v
      })
    },
    value: function (newVal, oldVal) {
      var vm = this
      vm.intent = Object.assign({}, vm.value)
      vm.cached_intent = Object.assign({}, vm.value)
      if (vm.intent.starttime) {
        var startTime = moment(vm.intent.starttime)
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = startTime.format('HH:mm')
      }
      if (vm.intent.endtime) {
        var endTime = moment(vm.intent.endtime)
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = endTime.format('HH:mm')
      }

      if (vm.value.a_type == 'text') {
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    },
    excludedIntentName: function () {
      var vm = this
      vm.intents = vm.excludedIntentName.split(',')
      vm.intents.push('comment')
      vm.intents.push('{default}')
      vm.intents.push('{welcome}')
      vm.intents.push('{default_comment_to_inbox}')

      if (vm.type == 'edit' && vm.excludedIntentName && vm.excludedIntentName != '' && vm.intent) {
        var result = []
        var names = vm.intents
        $.each(names, function (index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1)
            return false
          }
        })

        vm.excludedName = names.join(',').replace('|', '//#or//')
      } else {
        vm.excludedName = vm.intents.join(',').replace('|', '//#or//')
      }
    }
  }
}
</script>
<style lang="scss" scope>
.success--text {
  color: #ff706b !important;
  caret-color: #ff706b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue